<template>
  <div class="page-actions-bar page-secondary-background">
    <div class="container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActionsBar'
};
</script>

<style lang="scss">
.page-actions-bar {
  padding: 3rem 0 2rem;

  .container {
    .level > .level-item {
      justify-content: flex-start;
    }
  }
}
</style>
